export default __webpack_public_path__ + "static/media/038-trucks.286501dd.png";